<template>
    <div class="picture-vote">
        <div class="title">{{title}}</div>
        <!-- 2选项 -->
        <div v-if="isTwoOption" class="two-options">
            <div class="option" v-for="(item,index) in options" :key="item.id" @click="goToVote(item)">
                <img :src="item.optionUrl"/>
                <!-- 未投票 && 未结束 -->
                <div v-if="!isVoted&&!isFinish" class="two-option-status-1">{{item.name}}</div>
                <!-- 已投票 || 已结束 -->
                <template v-else>
                    <div class="two-option-status-2" :style="getTwoStatusStyle(item,index)">
                        <!-- 未完成，已选择 蓝色 -->
                        <div class="name">
                            <div class="left">
                                <div class="na">{{item.name}}</div>
                                 <div class="percent">{{item.percent}}%</div>
                                <img 
                                    v-if="userOptionId == item.id"
                                    class="selected-icon"
                                    :src="getTwoOptionSelectIcon(index)"
                                />
                            </div>
                        </div>
                        <div class="percent-bar"></div>
                    </div>
                </template>
            </div>
           </div>
        <!-- 3个选项 -->
        <div v-else-if="isThreeOption" class="three-options" >
            <template v-for="item in options">
                <!-- 未投票 && 未结束 -->
                <div :key="item.id" class="option" :style="getThreeStatusStyle(item)" @click="goToVote(item)">
                    <img :src="item.optionUrl"/>
                    <div :class="['percent-bar',canVote&&'no-percent-bar']">
                        <div class="name">
                            <div>{{item.name}}</div>
                            <!-- 选择icon -->
                            <div 
                                v-show="userOptionId == item.id" 
                                :class="['selected-icon',isFinish&&'selected-icon-finish']"
                            ></div>
                        </div>
                        <div class="percent" v-if="!canVote">{{item.percent}}%</div>
                    </div>
                </div>
            </template>
        </div>
        <!-- 4个选项 -->
        <div v-else class="four-options">
            <div class="option" v-for="item in options" :key="item.id" @click="goToVote(item)" :style="getFourStatusStyle(item)">
                <img :src="item.optionUrl"/>
                <!-- 未投票 && 未结束 -->
                <div v-if="!isVoted&&!isFinish" class="four-option-status-1">{{item.name}}</div>
                <!-- 已投票 || 已结束 -->
                <template v-else>
                    <div class="four-option-status-2">
                        <!-- 未完成，已选择 蓝色 -->
                        <div class="name">
                            <div class="left">
                                <div class="na">{{item.name}}</div>
                                 <div class="percent">{{item.percent}}%</div>
                                <img 
                                    v-if="userOptionId == item.id"
                                    class="selected-icon"
                                    :src="isFinish?greyIcon:blueIcon"
                                />
                            </div>
                        </div>
                        <div class="percent-bar"></div>
                    </div>
                </template>
            </div>
        </div>
        <!-- 提示信息 -->
        <Tips :fields="fields" :isFinish="isFinish"/>
    </div>
</template>
<script>
import Tips from './tips.vue'
import blueIcon from '../../../../less/images/icon_chose_blue@2x.png'
import greyIcon from '../../../../less/images/icon_chose_grey@2x.png'
export default {
    props: ['fields'],
    components: {
        Tips
    },
    data() {
        return {
            blueIcon,
            redIcon: '//statics.itc.cn/mptc-mpfe/img/article/icon_vote_chose_b.png',
            greyIcon
        }
    },
    computed: {
        title() {
            return this.fields?.title
        },
        options() {
            return this.fields?.options
        },
        // 2个选项
        isTwoOption() {
            return this.options?.length == 2
        },
        // 3个选项
        isThreeOption() {
            return this.options?.length == 3
        },
        // 多于2个选项
        isMulOption() {
            return !this.isTwoOption
        },
        // 可投票状态
        canVote() {
            return !this.isFinish && !this.userOptionId
        },
        // 已投票
        isVoted() {
            return this.fields?.userOptionId || false
        },
        // 已选选项
        userOptionId() {
            return this.fields?.userOptionId || ''
        },
        // 已结束
        isFinish() {
            return this.fields?.endTime && new Date().getTime() > this.fields?.endTime || false
        },
    },
    methods: {
        // 2图
        getTwoStatusStyle(item,index) {
            const isLeft = index == 0
            return {
                '--font-color': this.isFinish ? '#999' : isLeft ? '#4A70FF' : '#FF5E4D',
                '--background-color': this.isFinish ? '#fff' : isLeft ? '#E9EDFF' : '#FFEBE9',
                '--percent':item.percent+'%',
                '--resultbar-left-color': this.isFinish ? '#999' : isLeft ? '#4A70FF' : '#FF5E4D',
                '--resultbar-right-color': this.isFinish ? 'rgba(204,204,204,0.4)' : isLeft ? 'rgba(74,112,255,0.4)' : 'rgba(255,94,77,0.4)',
            }
        },
        // 3图
        getThreeStatusStyle(item) {
            const isSelected = item.id == this.userOptionId
            return {
                '--font-color': this.isFinish ? '#111' : !this.userOptionId ? '#558DDC' : isSelected ? '#1842DF' : '#111',
                '--percent-font-color': this.isFinish ? '#666' : isSelected ? '#1842DF' : '#666',
                '--resultbar-left-color': this.isFinish ? '#EBEBEB' : isSelected ? '#DFE6FF' : '#EBEBEB',
                '--font-weight': this.isFinish ? '400' : isSelected ? '500' : '400',
                '--percent': item.percent+'%',
                '--border-color': !this.isFinish && isSelected ? '#DFE6FF': '#EBEBEB'
            }
        },
        // 4图
        getFourStatusStyle(item) {
            const isSelected = item.id == this.userOptionId
            return {
                '--font-color': this.isFinish ? '#111' : isSelected ? '#1842DF' : '#111',
                '--background-color': this.isFinish ? '#fff' : isSelected ? '#F2F5FF' : '#fff',
                '--font-weight': this.isFinish ? '400' : isSelected ? '500' : '400',
                '--resultbar-left-color': this.isFinish ? '#999' : isSelected ? 'rgba(74,112,255,0.8)' : '#999',
                '--resultbar-right-color': this.isFinish ? '#e8e8e8' : isSelected ? '#D2DCFF' : '#e8e8e8',
                '--percent':item.percent+'%',
                '--border-color': !this.isFinish && isSelected ? '#DFE6FF': '#EBEBEB'
            }
        },
        getTwoOptionSelectIcon(index) {
            if(this.isFinish)return this.greyIcon
            if(index == 0)return this.blueIcon
            if(index == 1)return this.redIcon
            return this.blueIcon
        },
        goToVote(item) {
            this.$emit('sendVote',item)
        }
    }
}
</script>
<style lang="less" scoped>
.picture-vote {
    margin-bottom: 42px;/*px*/
    width: 100%;
    box-sizing: border-box;
    background: #F8F8F8;
    border-radius: 8px; /*px*/
    padding: 20px; /*px*/
    font-family: PingFangSC, PingFang SC;
    .title {
        font-weight: 600;
        font-size: 36px;/*px*/
        color: #111111;
        line-height: 52px;/*px*/
        text-align: left;
        font-style: normal;
    }
    .two-options {
        margin-top: 16px;/*px*/
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-right: -14px;/*px*/
        align-items: stretch;
        .option {
            flex: 1 1 calc(50% - 14px);/*px*/
            border-radius: 16px;/*px*/
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            align-items: stretch;
            img {
                width: 100%;
                height: auto;
                aspect-ratio: 1.2519 / 1; 
                object-fit: cover;
                border-radius: 16px 16px  0px 0px;/*px*/
                margin-bottom: 0 !important;
            }
            .two-option-status-1 {
                height: 64px;/*px*/
                background: #FF5E4D;
                border-radius: 0px 0px 16px 16px;/*px*/
                display: flex;
                justify-content: center;
                align-items: center;
                font-weight: 500;
                font-size: 28px;/*px*/
                color: #FFFFFF;
            }
            // 已投票&未结束
            .two-option-status-2 {
                border-radius: 0px 0px 16px 16px;/*px*/
                font-weight: 500;
                font-size: 24px;/*px*/
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: stretch;
                .name {
                    flex:1;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    color: var(--font-color);
                    background: var(--background-color);
                    padding: 6px 16px; /*px*/
                    font-size: 24px;/*px*/
                    .left {
                        display: inline-flex;
                        flex-wrap: wrap;
                        align-items: center;
                        
                        .na {
                            display: inline;
                            line-height: 36px;/*px*/
                        }
                        .percent {
                            margin-left: 8px;/*px*/
                            display: inline;
                            font-size: 24px !important;/*px*/
                        }
                        .selected-icon {
                            display: inline;
                            margin-left: 8px;/*px*/
                            width: 24px;/*px*/
                            height: 24px;/*px*/
                            margin-bottom: 0 !important;
                        }
                    }
                }
                .percent-bar {
                    height: 16px;/*px*/
                    border-radius: 0px 0px 16px 16px;/*px*/
                    background: linear-gradient(to right,var(--resultbar-left-color) var(--percent),var(--resultbar-left-color) var(--percent),var(--resultbar-right-color) var(--percent),var(--resultbar-right-color) 100%);
                }
            }
        }
        .option:first-child {
            margin-right: 14px;/*px*/
            .two-option-status-1 {
                background: #4A70FF;
            }
        }
        .two-finished {
            .option-name {
                display: flex;
                height: 32px;/*px*/
                margin-top: 16px;/*px*/
                justify-content: space-between;
                align-items: center;
                .left{
                    width: 50%;
                    display: flex;
                    align-items: center;
                    white-space: nowrap;
                    .left-name{
                        height: 32px;/*px*/
                        font-size: 24px;/*px*/
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        line-height: 32px;/*px*/
                        margin-right: 8px;/*px*/
                        max-width: 320px;/*px*/
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
                .selected-icon {
                    flex-shrink: 0;
                    width:28px;/*px*/
                    height: 28px;/*px*/
                    margin-bottom: 0 !important;
                    margin-left: 4px !important;/*px*/
                }
                .right{
                    width:50%;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    .right-name{
                        display: inline-block;
                        height: 32px;/*px*/
                        font-size: 24px;/*px*/
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        line-height: 32px;/*px*/
                        margin-left: 8px;/*px*/
                        max-width: 320px;/*px*/
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
            .result-bar {
                margin-top: 8px;/*px*/
                width:100%;
                height: 24px;/*px*/
                border-radius: 40px;/*px*/
            }
        }
    }
    // 3选项
    .three-options {
        .option {
            max-width: 100%;
            margin-top: 12px;/*px*/
            background: #FFFFFF;
            border-radius: 16px;/*px*/
            display: flex;
            img {
                width: 216px;/*px*/
                height: 162px;/*px*/
                flex-shrink: 0;
                border: 2px solid var(--border-color);/*px*/
                border-right-width: 0 !important;
                border-radius: 16px 0px 0px 16px;/*px*/
                margin-bottom: 0 !important;
                object-fit: cover;
            }
            .percent-bar {
                flex: 1;
                flex-shrink: 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
                box-sizing: border-box;
                padding: 0 32px;/*px*/
                color: var(--font-color);
                font-weight: 500;
                font-size: 28px; /*px*/
                border-radius: 0px 16px 16px 0px;/*px*/
                border: 2px solid var(--border-color);/*px*/
                border-left-width: 0 !important;
                margin-bottom: 0 !important;
                background: linear-gradient(to right,var(--resultbar-left-color) var(--percent),var(--resultbar-left-color) var(--percent),white var(--percent),white 100%);
                .name {
                    color: var(--font-color);
                    font-weight: var(--font-weight);
                    display: flex;
                    align-items: center;
                    flex: 1;
                    flex-shrink: 0;
                    overflow: hidden;
                    .selected-icon {
                        flex-shrink: 0;
                        margin-left: 8px;/*px*/
                        width: 24px;/*px*/
                        height: 24px;/*px*/
                        margin-bottom: 0 !important;
                        background: url('../../../../less/images/icon_chose_blue@2x.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .selected-icon-finish {
                        background: url('../../../../less/images/icon_chose_grey@2x.png') no-repeat;
                        background-size: 100% 100%;
                    }
                }
                .percent {
                    margin-left: 8px;/*px*/
                    color: var(--percent-font-color);
                    font-weight: 400;
                }
            }
            .no-percent-bar {
                background: white;
                .name {
                    justify-content: center;
                }
            }
        }
    }
    // 4选项
    .four-options {
        margin-top: 16px;/*px*/
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-right: -14px;/*px*/
        .option {
            margin-bottom: 12px;/*px*/
            border-radius: 16px;/*px*/
            flex: 1 1 calc(50% - 14px);/*px*/
            display: flex;
            flex-direction: column;
            border: 2px solid var(--border-color);/*px*/
            box-sizing: border-box;
            margin-right: 14px;/*px*/
            img {
                width: 100%;
                height: auto;
                aspect-ratio: 1.2519 / 1; 
                object-fit: cover;
                border-radius: 16px 16px  0px 0px;/*px*/
                margin-bottom: 0 !important;
            }
            .four-option-status-1 {
                height: 64px;/*px*/
                background: #fff;
                border-radius: 0px 0px 16px 16px;/*px*/
                display: flex;
                justify-content: center;
                align-items: center;
                font-weight: 500;
                font-size: 28px;/*px*/
                color: #558DDC;
            }
            .four-option-status-2 {
                background: #fff;
                border-radius: 0px 0px 16px 16px;/*px*/
                font-weight: 500;
                font-size: 28px;/*px*/
                display: flex;
                flex-direction: column;
                align-items: stretch;
                flex: 1;
                .name {
                    width: 100%;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    align-items: stretch;
                    flex-wrap: wrap;
                    font-weight: var(--font-weight);
                    font-size: 24px;/*px*/
                    background: var(--background-color);
                    color: var(--font-color);
                    padding: 6px 16px; /*px*/
                    flex: 1;
                    .left {
                        display: inline-flex;
                        flex-wrap: wrap;
                        align-items: center;
                        .na {
                            display: inline;
                            line-height: 36px;/*px*/
                            margin-right: 8px;/*px*/
                        }
                        .percent {
                            margin-right: 8px;/*px*/
                            display: inline;
                            font-size: 24px !important;/*px*/
                        }
                        .selected-icon {
                            flex-shrink: 0;
                            width: 24px;/*px*/
                            height: 24px;/*px*/
                        }
                    }
                }
                .percent-bar {
                    height: 16px;/*px*/
                    border-radius: 0px 0px 16px 16px;/*px*/
                    background: linear-gradient(to right,var(--resultbar-left-color) var(--percent),var(--resultbar-left-color) var(--percent),var(--resultbar-right-color) var(--percent),var(--resultbar-right-color) 100%);
                }
            }
        }
        .option:nth-child(3) {
            margin-bottom: 0;
        }
        .option:nth-child(4) {
            margin-bottom: 0;
        }
    }
    

}
</style>